import styled from 'styled-components';
export const EmptyStateContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8rem 0;

  text-align: center;

  width: 100%;
`;
export const ImgWrapper = styled.div `
  margin-bottom: 0.5rem;
`;
export const Img = styled.img `
  height: 23rem;
`;
export const DescriptionWrapper = styled.div `
  text-align: center;

  margin-top: 0.7rem;
`;
export const LoadingStateContainer = styled.div `
  display: flex;
  justify-content: center;

  padding: 8rem 0;

  width: 100%;
`;
//# sourceMappingURL=styles.js.map